var $ = require('jquery');
var _ = require('../../../com/underscore.js');
var user = require('../common/user.js');
var msgbox = require('../common/msgbox.js');
var orderInterval = null;
var orderCounter = 0;
var typeData = '';
var aidfrom = '';
var tipsid = '';

/*获取html片段*/
function getHtml(url, data, callback) {
    $.ajax({
        url: url,
        type: 'get',
        data: data,
        dataType: 'html'
    }).done(function(json) {
        callback(json);
    }).fail(function() {
        console.log("error");
    });
};

var typeConfig = {
    'originPay': {
        'url': 'http://vip.xunlei.com/pagepiece/renew/original-pay.html',
        'heightClass': 'pop_460x460',
        'popid': 'hygw_tips_2'
    },
    'salePay': {
        'url': 'http://vip.xunlei.com/pagepiece/renew/sale-pay.html',
        'heightClass': 'pop_460x460',
        'popid': 'hygw_tips_1'
    },
    'expiredMode1': {
        'url': 'http://vip.xunlei.com/pagepiece/renew/expired-mode1.html',
        'heightClass': 'pop_460x460',
        'popid': 'hygw_tips_3'
    },
    'expiredMode2': {
        'url': 'http://vip.xunlei.com/pagepiece/renew/expired-mode2.html',
        'heightClass': 'pop_480x480',
        'popid': 'hygw_tips_4'
    }
}


/*
 * 生成图片二维码
 */
function formSuperCode(data) {
    var imgSrc = 'http://m.pay.xunlei.com/vippay/qrcode?'
    for (var name in data) {
        imgSrc += name + '=' + data[name] + '&';
    }
    return imgSrc + '_v=' + new Date().getTime();
}

function formSuperCodeJson(data, callback) {
    var url = 'http://m.pay.xunlei.com/vippay/qrcode?';
    // for (var name in data) {
    //     url += name + '=' + data[name] + '&';
    // }

    $.ajax({
        type: "get",
        url: url,
        data: data,
        dataType: "jsonp",
        success: function(rs) {
            if (typeof callback == 'function') {
                callback(rs);
            }
        }
    });
}

/*
 * 获取交易id
 */
function setTradeId(month) {
    var vastype = getCookie('vas_type');
    var submitMonth = month >= 10 ? month : '0' + month;
    if(vastype == 5){
        return tradeid = '14' + submitMonth;
    }else{
        return tradeid = '11' + submitMonth;
    }
}

/*
 * 动作时间操作
 */
function initEvent(type) {
    $('#pay-list li').unbind().click(function(event) {
        $('#pay-list li').removeClass('cho');
        $(this).addClass('cho');
        showPriceAndGetCode($(this).attr('data-month'), $(this).attr('data-price'), 'v_pc_hygw_push_tips_center', type);

        /* Act on the event */
    });

    $('#renew-pop').on('click', '.link_refresh', function(){
        $('#pay-list').find('li.cho').click();
        $('#code-img').parent().find(".mask_off").hide();
    }).on('click', '.btn_red', function(){
        if(xla && xla.push){
            xla.push({
                type: 'event',
                category: 'hygw_centertips',
                action: 'centertips_click',
                extdata: {
                    pageid: typeData.popid,
                    tipsid: tipsid,
                    userid: getCookie('userid')
                }
            });
        }
    }).on('click', '.p_b_close', function(){
        if(xla && xla.push){
            xla.push({
                type: 'event',
                category: 'hygw_centertips',
                action: 'centertips_close',
                extdata: {
                    pageid: typeData.popid,
                    tipsid: tipsid,
                    userid: getCookie('userid')
                }
            });
        }
    }).on('click', '.link_otherpay', function(){
        if(getCookie('vas_type') == 5){  // 超级会员
            window.open('https://pay.xunlei.com/pay.html?bizNo=baijin&mref=116&selectBizno=baijin&timeType=1412&selectWay=qrcode&referfrom=v_pc_hygw_push_tips_center');
        }else{
            window.open('https://pay.xunlei.com/pay.html?bizNo=baijin&mref=116&selectBizno=baijin&timeType=1112&selectWay=qrcode&referfrom=v_pc_hygw_push_tips_center');
        }
    });
}

/*
 * 用户价格的显示
 */
function showPriceAndGetCode(month, money, referfrom, type) {
    // perMonth = (money / month).toFixed(1);
    perMonth = getCookie('vas_type') == 5 ? (month * 30 - money) : (month * 15 - money);
    $('#total-moeny').text(money + '元');
    $('#per-month').text('省' + perMonth + '元');
    if (type = 1) {
        var tradeid = setTradeId(month);
        var data = {
            qrcode: 1,
            version: 1.5,
            opid: 'web',
            pid: 'pc',
            userid: getCookie('userid'),
            sessionid: getCookie('sessionid'),
            mref: 105,
            referfrom: referfrom,
            days: '',
            tradeid: tradeid,
            auto: 0,
            aidfrom: aidfrom
        };

        // if(month == 12 && getCookie('vas_type') != 5){
        //     data = {
        //         'version': 'v2.0',
        //         'userid': getCookie('userid'),
        //         'sessionid': getCookie('sessionid'),
        //         'opid': 'web',
        //         'activeid': '2003001',
        //         'bizno': 'baijin',
        //         'num': '13',
        //         'rmb': '149',
        //         'ext2': $.param({
        //             actid: 'xl9minipage_bj',
        //             pid: 'bj13_149'
        //         }),
        //         '_v': (new Date()).getTime(),
        //         'mref': 105,
        //         'referfrom': referfrom,
        //         'aidfrom': aidfrom
        //     };
        // }
        formSuperCodeJson(data, function(rs){
            if (rs.data.code == 300) {
                $('#code-loading').hide();
                $('#code-img').attr('src', rs.data.qrcode).show();

                try {
                    clearInterval(orderInterval);
					orderCounter = 0;
					$('#code-img').parent().find(".mask_off").hide();
                } catch (e) {

                }

                orderInterval = setInterval(function() {
					orderCounter ++;
					if(orderCounter > 400){  // 400  超过20分钟，则不再发送请求
						clearInterval(orderInterval);
						$('#code-img').parent().find(".mask_off").show();
						return;
					}
                }, 3000);
            }
        });
    }
}

/*
 * 获取区间的类型
 */
function getType(day) {
    if (15 >= day && 10 <= day) {
        aidfrom = 'af_exp_10_15_qrcode';
        tipsid = 700007;
        return 1;
    } else if (9 >= day && 4 <= day) {
        aidfrom = 'af_exp_4_9_qrcode';
        tipsid = 700005;
        return 6;
    } else if (3 >= day && 1 <= day) {
        aidfrom = 'af_exp_1_3_qrcode';
        tipsid = 700004;
        return 2;
    } else if (0 == day) {
        aidfrom = 'bf_exp_0_qrcode';
        tipsid = 700003;
        return 3;
    } else if (-3 <= day && -1 >= day) {
        aidfrom = 'bf_exp_1_3_qrcode';
        tipsid = 700002;
        return 4;
    } else if (-9 <= day && -4 >= day) {
        aidfrom = 'bf_exp_4_9_qrcode';
        tipsid = 700006;
        return 5;
    } else if (-15 <= day && -10 >= day) {
        aidfrom = 'bf_exp_10_15_qrcode';
        tipsid = 700001;
        return 7;
    } else {
        return 0;
    }
}

function init() {
    var expiredays = getCookie('vip_expiredays'),
        type = getType(expiredays),
        isVip = getCookie('vip_isvip'),
        renewPop = getCookie('renew_pop_' + getCookie('userid')),
        popType;

    if(type == 0){
        return;
    }

    if (renewPop) {
        var renewCookieArry = renewPop && renewPop.split('_') || [];
        if (renewCookieArry[0] == isVip && renewCookieArry[1] == type) { //该规则配置下已经弹过弹窗
            return;
        } else {
            if (renewCookieArry[0] != isVip) {
                popType = getPopType(isVip);
            } else {
                popType = renewCookieArry[2]; //弹窗类型
            }
            showRenewPop(popType);
            setPopCookie(isVip, type, popType);
        }

    } else {
        popType = getPopType(isVip);
        showRenewPop(popType);
        setPopCookie(isVip, type, popType);
    }
}

/*
 * 用户显示弹窗
 */
function showRenewPop(type) {
    typeData = typeConfig[type];
    getHtml(typeData.url, {}, function(rs) {
        var tpl = rs;
        $('#renew-pop').addClass(typeData.heightClass).html((_.template(tpl))({
            'avatar': user.avatar(),
            'icon': user.vipIcon(),
            'nameClass': user.isVip() ? '#C80000' : '#383838',
            'userName': user.nickname(),
            'expiredays': Math.abs(getCookie('vip_expiredays')),
            'vastype': getCookie('vas_type')
        }));
        switch (type) {
            case 'originPay':
                initEvent(1);
                $('#pay-list li').eq(0).click();
                break;
            case 'salePay':
                showEndTime();
                initEvent(1);
                $('#pay-list li').eq(0).click();
                break;
            case 'expiredMode1':
                initEvent(1);
                $('#pay-list li').eq(0).click();
                break;
            case 'expiredMode2':
                initEvent();
                break;
        }
        // send_web_pv('adshow', {
        //     'clickid': typeData.popid
        // });
        msgbox.showDiv('renew-pop');

        if(xla && xla.push){
            xla.push({
                type: 'event',
                category: 'hygw_centertips',
                action: 'centertips_show',
                extdata: {
                    pageid: typeData.popid,
                    tipsid: tipsid,
                    userid: getCookie('userid')
                }
            });
        }
    })
}

/*
 *设置弹窗的cookie
 *@isvip 会员身份
 *@type 显示的条件类型
 *@poptype显示的弹窗类型
 */
function setPopCookie(isvip, type, poptype) {
    setRealCookie('renew_pop_' + getCookie('userid'), isvip + '_' + type + '_' + poptype, 360);
}

/*
 * 随机显示弹窗浮层样式
 */
function getPopType(isvip) {
    var popType = '';
    if (isvip == 1) {
        popType = 'originPay';
    } else {
        popType = 'expiredMode1';
    }
    return popType;
}

/*
 *倒计时
 */
function showEndTime() {
    var ele = $('.countdown');
    var vipExpDate = new Date(getCookie('vip_expiredate').replace(/-/g, '/'));
    vipExpDate.setDate(vipExpDate.getDate() + 1);
    var expireTime = (vipExpDate.getTime() - new Date().getTime())/1000;
    var time = expireTime >= 0 ? expireTime : -1;
    var interval = ele.data('interval') || 1000;
    if (isNaN(time) || Math.floor(time) < 0) {
        clearTimeout(window.run);
        msgExit();
    } else {
        var dd = parseInt(time / 60 / 60 / 24);
        var hh = parseInt((time - dd * 24 * 3600) / 60 / 60);
        var mm = parseInt((time - dd * 24 * 3600 - hh * 3600) / 60);
        var ss = parseInt(time - dd * 24 * 3600 - hh * 3600 - mm * 60);
        var ms = parseInt(time * 100 - dd * 24 * 3600 * 100 - hh * 3600 * 100 - mm * 60 * 100 - ss * 100);
        dd = dd > 9 ? dd + '' : '0' + dd;
        hh = hh > 9 ? hh + '' : '0' + hh;
        mm = mm > 9 ? mm + '' : '0' + mm;
        ss = ss > 9 ? ss + '' : '0' + ss;
        ms = ms + '';
        if (ms.length == 1) {
            ms = '0' + ms;
        }

        ele.html('<span class="colon">还剩</span><span class="num"><i>' + dd +
            '</i></span><span class="colon">天</span><span class="num"><i>' + hh +
            '</i></span><span class="colon">时</span><span class="num"><i>' + mm + '</i></span><span class="colon">分</span>');
        time = (time * 1000 - interval) / 1000;
        time = time.toFixed(2);
        try {
            clearTimeout(window.run);
        } catch (e) {}
        window.run = setTimeout(function() {
            showEndTime();
        }, interval);
    }
}

module.exports = function() {
    if (haslogin() && Math.abs(getCookie('vip_expiredays') || 100) <= 15 && (getCookie('is_vip') == 1 || getCookie('is_vip') == 0)) {
        init();
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/renew/renew2.js
// module id = 9
// module chunks = 0